<template>
  <nav
    class="tabs"
    :class="{'tabs-boxed': boxed, 'tabs-expanded': expanded}"
  >
    <a
      v-for="(tab, index) in tabs"
      :key="tab.id || index"
      :class="{active: (tab.id || index) === value, disabled: tab.disabled}"
      href="#"
      @click.prevent="select(tab.id || index)"
    >{{ tab.name }}</a>
  </nav>
</template>

<script>
export default {
  props: {
    /**
     * The current value of the selected tab.
     */
    value: {
      type: [Number, String],
      default: 0,
    },

    /**
     * List of Names for each Tab.
     */
    tabs: {
      type: Array,
      required: true,
      validator: (value) => value.length >= 1,
    },

    /**
     * Applyes the Boxed style.
     */
    boxed: {
      type: Boolean,
      default: false,
    },

    /**
     * Applyes the Expanded style.
     */
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    select (tabIndex) {
      /**
       * Emitted when a tab is selected. Used to update the v-model.
       *
       * @property {number | string} tabIndex Current selected tab index (0-based index) or tab id
       */
      this.$emit('input', tabIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid $gray-200;

  &-boxed {
    border-top: 1px solid $gray-200;

    a {
      padding-left: 1rem;
      padding-right: 1rem;
      margin-right: 0 !important;

      &.active,
      &.active:focus {
        border-left: none;
        border-right: none;
        margin-right: 2px !important;
        margin-left: 2px;
        border-radius: 0;
      }
    }
  }

  &-expanded {
    > a {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
      text-align: center;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  a {
    color: $gray-800;
    font-size: 1rem;
    padding-top: 0.675rem;
    padding-bottom: 0.675rem;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    font-weight: normal;
    margin-right: 2rem;
    border: 2px solid transparent;

    &:hover {
      color: $cyan-700;
      text-decoration: none;
    }

    &:focus {
      outline: none;

      &:not(:active) {
        color: $cyan-700;
        border-color: $cyan-500;
        border-radius: 2px;
      }
    }

    &.disabled {
      color: $gray-300;
      pointer-events: none;
      cursor: default;
      user-select: none;
    }

    &.active,
    &.active:focus {
      color: $gray-900;
      border-color: transparent;
      border-bottom-color: $gray-900;
      border-left: none;
      border-right: none;
      margin-right: calc(2rem + 2px);
      margin-left: 2px;
      border-radius: 0;
    }
  }
}
</style>
